// #region imports

// --- Angular
import {
  HttpEvent,
  HttpHandler,
  HttpInterceptor,
  HttpRequest
} from '@angular/common/http';
import { Injectable } from '@angular/core';

// --- RxJs
import { Observable, forkJoin } from 'rxjs';
import { switchMap } from 'rxjs/operators';
import { NEVER } from 'rxjs';

// --- 3rd Party
import { TranslateService } from '@ngx-translate/core';

// --- HS Code
import { AppService } from '../services/app.service';
import { AppToastService } from '../services/app-toast.service';
import { ToastModel } from '../../models';

// #endregion

@Injectable({
  providedIn: 'root'
})
export class NetWorkInterceptorService implements HttpInterceptor {
  static oidcInterceptorService: any;

  private _timeOut: any;

  constructor(
    private appService: AppService,
    private toastService: AppToastService,
    private translate: TranslateService
  ) {}

  intercept(
    request: HttpRequest<any>,
    next: HttpHandler
  ): Observable<HttpEvent<any>> {
    return this.appService.isOffLine$.pipe(
      switchMap(isOffLine => {
        if (isOffLine) {
          if (this._timeOut) {
            clearTimeout(this._timeOut);
          }
          this._timeOut = window.setTimeout(this._showToastAlert.bind(this), 300);
          return NEVER;
        }
        return next.handle(request);
      })
    );
  }

  private _showToastAlert() {
    forkJoin(
      this.translate.get('networkDownHeader'),
      this.translate.get('networkDownBody')
      ).subscribe(([header, body]) => {
        const toastModel = {
          header,
          body,
          autoHide: true,
          class: 'bg-danger text-light',
          delay: 5000
        } as ToastModel;

        this.toastService.show(toastModel);
      });
  }
}
